import { createSlice } from '@reduxjs/toolkit';
import { CustomerType, DocumentType } from '../../../types';

export interface DocumentFormValues {
  documentPath?: string;
  documentGroup?: DocumentType;
  documentName?: string;
}

export interface CustomerDocumentCreate {
  requestInProgress: boolean;
  formValues: DocumentFormValues;
  onAddSuccess?: boolean;
  fileUploadInProgress?: boolean;
  documentName?: string;
  customerId?: string;
  customerType?: CustomerType;
}

const initialState: CustomerDocumentCreate = {
  requestInProgress: false,
  onAddSuccess: false,
  fileUploadInProgress: false,
  formValues: {},
};

export const customerDocumentCreateSlice = createSlice({
  name: 'customerDocumentCreate',
  initialState,
  reducers: {
    clearDocumentFormState: (state) => {
      state.requestInProgress = false;
      state.onAddSuccess = false;
      state.fileUploadInProgress = false;
      state.documentName = undefined;
      state.customerId = undefined;
      state.customerType = undefined;
      state.formValues = {};
    },
  },
});

export const { clearDocumentFormState } = customerDocumentCreateSlice.actions;

export default customerDocumentCreateSlice.reducer;
